import Spinner from 'react-bootstrap/Spinner';
import { useEffect, useState, useRef } from 'react';
import { Navigate } from "react-router-dom";
import jsPDF from 'jspdf';
import Layout from '../../layout/default';
import { useApiClient } from '../../ApiService/useApiClient';

const InvoiceDetail = ({ invoiceId }) => {

  const api = useApiClient();
  const dataFetchedRef = useRef(false);
  const invoiceRef = useRef(); // ✅ Ref for invoice container
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const baseURL = "HMCareInvoice/invoice/" + invoiceId;

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
  
    api.get(baseURL)
      .then((Response) => {
        setData(Response.data);
      }).catch(error => {
        setError(error);
        console.log({ error });
      });

  }, []);

  if (error) {
    if (error.message.indexOf("status code 401")) {
      return <Navigate to="/auths/auth-login" />
    } else {
      return `Error: ${error.message}`;
    }
  }

  if (!data) return (
    <Spinner animation="border" variant="primary" />
  );

  const handleDownloadPDF = () => {
    const doc = new jsPDF({
      unit: 'pt',
      format: 'a4',
      putOnlyUsedFonts: true
    });

    doc.html(invoiceRef.current, {
      margin: [20, 20, 20, 20],
      html2canvas: { scale: 0.7 },
      callback: function (doc) {
        doc.save(`invoice_INV00${data.invHeader.invoiceId}.pdf`);
      }
    });
  };

  return (
    <>
      <div className="text-end mb-3">
        <button className="btn btn-primary" onClick={handleDownloadPDF}>
          Download PDF
        </button>
      </div>

      {/* ✅ Wrap the invoice content in a ref */}
      <div ref={invoiceRef} className="invoice" style={{ width: '100%', margin: '0 auto', padding: '20px', border: '1px solid #ccc', backgroundColor: '#fff' }}>
        <div className="invoice-header" style={{ padding: '10px 0', borderBottom: '1px solid #ccc', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div style={{ flex: 1 }}>
            <p style={{ margin: '5px 0' }}>
              Date: {data.invHeader.dateCreated && new Date(data.invHeader.dateCreated).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
            </p>
          </div>
          <div style={{ flex: 1, textAlign: 'right' }}>
            <p style={{ margin: '5px 0' }}>Invoice Number: INV00{data.invHeader.invoiceId}</p>
          </div>
        </div>

        <div className="invoice-addresses" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="invoice-from" style={{ flex: 1 }}>
            <h3>Invoice From</h3>
            <p style={{ margin: '5px 0' }}>
              {data.invHeader.invFromAddress && data.invHeader.invFromAddress.split(',').map((line, index) => (
                <div key={index}>{line.trim()}</div>
              ))}
              {data.invHeader.invFromEmail && <div>{data.invHeader.invFromEmail}</div>}
              {data.invHeader.invFromPhone && <div>{data.invHeader.invFromPhone}</div>}
            </p>
          </div>
          <div className="invoice-to" style={{ flex: 1, textAlign: 'right', paddingRight: "10px" }}>
            <h3>Invoice To</h3>
            <p style={{ margin: '5px 0' }}>
              {`${data.invHeader.firstName ?? ""} ${data.invHeader.lastName ?? ""}`}<br />
              {data.invHeader.companyAdd1 && <div>{data.invHeader.companyAdd1}</div>}
              {data.invHeader.companyAdd2 && <div>{data.invHeader.companyAdd2}</div>}
              {data.invHeader.companyAdd3 && <div>{data.invHeader.companyAdd3}</div>}
              {data.invHeader.companyAdd4 && <div>{data.invHeader.companyAdd4}</div>}
              {data.invHeader.postcode && <div>{data.invHeader.postcode}</div>}
              {data.invHeader.emailAddress && <div>{data.invHeader.emailAddress}</div>}
              {data.invHeader.companyTelNo && <div>{data.invHeader.companyTelNo}</div>}
            </p>
          </div>
        </div>

        <div className="invoice-body" style={{ padding: '10px 0' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Service</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Total Hours</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Unit Price (£)</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Total (£)</th>
              </tr>
            </thead>
            <tbody>
              {data.invDetail && data.invDetail.map((detail, index) => (
                <tr key={index}>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{detail.proName}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{detail.noOfHours.toFixed(1)}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{detail.customerHourlyRate.toFixed(2)}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{detail.lineTotal.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="invoice-footer" style={{ textAlign: 'right' }}>
          <p style={{ margin: '5px 0' }}>Subtotal: £ {data.invHeader.invoiceTotal_ex_vat?.toFixed(2)}</p>
          <p style={{ margin: '5px 0' }}>VAT: £ {data.invHeader.invoiceTotal_vat?.toFixed(2)}</p>
          <h3 style={{ margin: '5px 0' }}>Total (incl. VAT): £ {data.invHeader.invoiceTotal?.toFixed(2)}</h3>
        </div>
      </div>
    </>
  );
};

export default InvoiceDetail;
